/* eslint-disable react/require-default-props */
import React from 'react';
import {WithTranslationProps} from 'react-i18next';
import {get} from 'lodash';

import SectionHeader from '/component/base/SectionHeader';
import {useMyTeamsContext} from '/component/screen/report/MyTeamsReport/hooks/useMyTeamsContext';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
interface ReportMeta {
  page: {
    filtercount: number;
  };
  report: {
    total: number;
  };
}

interface MyTeamsListHeaderProps extends WithTranslationProps {
  reportMeta: ReportMeta | null;
  reportName: string;
  reportIsLoading: boolean;
  tt: (key: string, callback?: any) => string;
  viewTeamsReportFilterCount: number;
  viewTeamsReportCountAllOrg: number;
  watchlistCount: number;
  ffTeamsOrgSR?: boolean;
}

export const MyTeamsListHeader: React.FC<MyTeamsListHeaderProps> = ({
  tt = withTranslation.ttDefaultProp,
  reportMeta = null,
  reportName = '',
  reportIsLoading = true,
  viewTeamsReportFilterCount = 0,
  viewTeamsReportCountAllOrg = 0,
  watchlistCount = 0,
  ffTeamsOrgSR,
}) => {
  let total: number;
  let displayCount: number;
  const {reduxActiveTab, reduxIsViewTeam} = useMyTeamsContext();
  // func to check if any filters are applied
  const isFilterApplied = (meta: any): boolean => {
    if (!meta) return false;

    const {
      periodFilter = ffTeamsOrgSR ? 'any' : 'all',
      fibcFilter = 'any',
      frontlineFilter = '0',
      rankFilter = '[]',
      nextRankFilter = '0',
      cabEarned,
      aabEarned,
      fqvMin,
      fqvMax,
      newClientsAbove,
      newClientsBelow,
      qualifiedClientsAbove,
      qualifiedClientsBelow,
      newCoachesAbove,
      newCoachesBelow,
    } = meta;

    return (
      periodFilter !== (ffTeamsOrgSR ? 'any' : 'all') ||
      fibcFilter !== 'any' ||
      frontlineFilter !== '0' ||
      (rankFilter && rankFilter !== '[]') ||
      nextRankFilter !== '0' ||
      !!cabEarned ||
      !!aabEarned ||
      fqvMin !== undefined ||
      fqvMax !== undefined ||
      newClientsAbove !== undefined ||
      newClientsBelow !== undefined ||
      qualifiedClientsAbove !== undefined ||
      qualifiedClientsBelow !== undefined ||
      newCoachesAbove !== undefined ||
      newCoachesBelow !== undefined
    );
  };
  if (reduxActiveTab === 'watchlist') {
    total = Number(get(reportMeta, 'report.total', 0));

    if (isFilterApplied(reportMeta)) {
      displayCount = Number(get(reportMeta, 'page.filtercount', 0));
    } else {
      displayCount = watchlistCount;
    }
  } else if (reduxIsViewTeam) {
    total = viewTeamsReportCountAllOrg || 0;
    displayCount = viewTeamsReportFilterCount || 0;
  } else {
    total = Number(get(reportMeta, 'report.total', 0));
    displayCount = Number(get(reportMeta, 'page.filtercount', 0));
  }

  let displayText = '';

  if (displayCount === 0) {
    displayText = `0 of ${total} ${total === 1 ? 'Coach' : 'Coaches'}`;
  } else if (displayCount === total) {
    displayText = `${total} ${total === 1 ? 'Coach' : 'Coaches'}`;
  } else {
    displayText = `${displayCount} of ${total} ${
      total === 1 ? 'Coach' : 'Coaches'
    }`;
  }

  return (
    <SectionHeader
      isViewTeam={reduxIsViewTeam}
      reportName={reportName}
      reportIsLoading={reportIsLoading}
      reportMeta={reportMeta}>
      {tt(
        'totalCoachesCount',
        generateComponentCallback({
          component: <>{displayText}</>,
        }),
      )}
    </SectionHeader>
  );
};

export default withTranslation('report.list.coachesHeader')(MyTeamsListHeader);
